import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { parse } from '@atlassian/cs-ari';
// Convert an extensionId ARI into attributes to add to the analytics event
export function extensionIdToAnalyticsAttributes(extensionId) {
  if (!extensionId) {
    return {};
  }
  try {
    var ari = parse(extensionId);
    if (!ari.resourceId) {
      return {};
    }
    var _ari$resourceId$split = ari.resourceId.split('/'),
      _ari$resourceId$split2 = _slicedToArray(_ari$resourceId$split, 4),
      appId = _ari$resourceId$split2[0],
      environmentId = _ari$resourceId$split2[1],
      groupId = _ari$resourceId$split2[2],
      extensionKey = _ari$resourceId$split2[3];
    return {
      appId: appId,
      environmentId: environmentId,
      groupId: groupId,
      extensionKey: extensionKey
    };
  } catch (_unused) {
    return {};
  }
}